const locale = require('./emailEditor.i18n.json');

/*@ngInject*/
const EmailEditorController = function ($rootScope, $scope, $timeout, $window, $sanitize, coreConstant, coreMediator, emailMessageStatus, modalUtil, attachmentUtil, loadingBarHandler, dataSetUtil, emailEditorConstant, emailMessage) {

    this.$onInit = function () {
        this.emailI18n = locale;
        this.email = this.options.email;
        this.ccVisible = this.options.email.cc;
        this.bccVisible = this.options.email.bcc;
        this.body = _.clone(this.options.email.body);
        this.subject = _.clone(this.options.email.subject);
        this.toRecipients = [];
        this.ccRecipients = [];
        this.bccRecipients = [];
        this.peoplePickerList = [];
        this.filteredPeoplePickerList = [];
        this.submissionParticipantsList = [];
        this.addAnAttachmentText = this.emailI18n.attachmentTooltip;
        this.typeDataItems = [];
        this.selectedEmailType = null;
        this.emailTypePlaceholder = this.emailI18n.type;
        this.draftTitle = this.emailI18n.draftTitle;
        this.invalidEmailAddressTooltip = this.emailI18n.invalidEmailAddressTooltip;

        $scope.onAttachmentDownloadClick = (attachment) => {
            attachmentUtil.getAttachmentLinkURL(attachment.id, attachment.name).then((url) => {
                $window.open(url, '_blank');
            });
        };

        $scope.validateEmailAddress = function (emailAddress) {
            let recipientEmailValidator = angular.element('.recipientEmailValidator')[0];
            recipientEmailValidator.value = emailAddress;
            return recipientEmailValidator.checkValidity();
        };

        $scope.transformFreeFormEmailAddress = function (item) {
            let recipientObject = {
                id: item,
                emailAddress: item,
                valid: $scope.validateEmailAddress(item)
            };
            return recipientObject;
        };

        $scope.getValue = function (item) {
            if (item.description) {
                return '"' + item.description + '"';
            } else if (item.name && item.emailAddress) {
                return '"' + item.name + '" <' + item.emailAddress + '>';
            } else if (item.name) {
                return '"' + item.name + '"';
            } else if (item.emailAddress) {
                return '"' + item.emailAddress + '"';
            }
        };

        $scope.$on(coreConstant.event.FILE_DROPPED, (event, file) => {
            if (file && attachmentUtil.validateAttachment(file, _.get(this.emailI18n, 'unacceptableType'))) {
                this.showAddNewAttachmentModal(file);
            }
        });

        $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
            $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
        });

        $scope.$on(coreConstant.event.CLOSE_EMAIL_POPUP, () => {
            this.onCloseClick();
        });

        $scope.$on(coreConstant.event.ATTACHMENT_UPDATED, (event, availableAttachments, selectedAttachments, isAttachmentDropdownOpen) => {
            this.availableAttachments = availableAttachments;
            this.selectedAttachments = selectedAttachments;
            this.isAttachmentDropdownOpen = isAttachmentDropdownOpen;
        });

        $scope.$on(emailEditorConstant.event.PEOPLE_LIST_LOADED, (event, userList) => {
            this.loadUserList(userList);
            this.init();
        });


        if (this.isModeUms) {
            this.isDraftEmail = this.options.email.status === emailMessageStatus.STATUS_DRAFT;
            this.selectedAttachments = _.clone(this.selectedEmailAttachments);
            this.isAttachmentDropdownOpen = this.isEmailAttachmentDropdownOpen;
            this.availableAttachments = this.availableEmailAttachments;
            this.canDeleteEmail = this.options.canDeleteEmail;
        }

        $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

        this.init();
        this.loadUserList(this.userList);
        if (this.readOnly) {
            $timeout(function () {
                $scope.editor.summernote('disable');
            }, 0);
        }
    };

    this.onDeleteClick = function () {
        let config = {
            cancelButtonLabel: this.emailI18n.cancel,
            confirmActionButtonLabel: this.emailI18n.confirm,
            summary: this.emailI18n.deleteConfirmationMessage,
            title: this.emailI18n.deleteConfirmationTitle
        };

        modalUtil.showGenericConfirm(config).then(() => {
            this.options.deleteEmail(this.getUpdatedEmail());
            this.closePopup();
        });
    };

    this.areRecipientsValid = function (checkRecipientExistence) {
        let recipientsExist = this.toRecipients.length !== 0 ||
            this.ccRecipients.length !== 0 ||
            this.bccRecipients.length !== 0,
            toRecipientsValid = doValidate(this.toRecipients),
            ccRecipientsValid = doValidate(this.ccRecipients),
            bccRecipientsValid = doValidate(this.bccRecipients);

        function doValidate(recipients) {
            return _.filter(recipients, function (recipient) {
                return !recipient.valid;
            }).length === 0;
        }

        return toRecipientsValid && ccRecipientsValid && bccRecipientsValid && (!checkRecipientExistence || recipientsExist);
    };

    this.userMadeChanges = function (emailType, modifiedEmailType) {
        if (this.options.email.subject !== this.subject) {
            return true;
        } else if (this.options.email.body !== this.body) {
            return true;
        } else if (this.options.email.to !== this.concatenateRecipients(this.toRecipients)) {
            return true;
        } else if (this.options.email.cc !== this.concatenateRecipients(this.ccRecipients)) {
            return true;
        } else if (this.options.email.bcc !== this.concatenateRecipients(this.bccRecipients)) {
            return true;
        } else if (!_.isEqual(this.options.email.attachments, this.selectedAttachments)) {
            return true;
        } else if (emailType !== modifiedEmailType) {
            return true;
        }

        return false;
    };

    this.onCloseClick = function () {
        let areRecipientsValid = this.areRecipientsValid(),
            config,
            emailType = this.options.email.type,
            modifiedEmailType = !_.isNil(this.selectedEmailType) ? this.selectedEmailType.name : null;

        if (this.userMadeChanges(emailType, modifiedEmailType) || this.options.deleteNewEmailOnCancel) {
            config = {
                cancelButtonLabel: areRecipientsValid ? this.emailI18n.closeConfirmation.cancel : this.emailI18n.closeConfirmation.alternate,
                confirmActionButtonLabel: this.emailI18n.closeConfirmation.confirm,
                summary: areRecipientsValid ? this.emailI18n.closeConfirmation.closeConfirmationMessage : this.emailI18n.closeConfirmation.invalidCloseConfirmationMessage,
                title: this.emailI18n.closeConfirmation.closeConfirmationTitle
            };

            if (areRecipientsValid) {
                config.alternateButtonLabel = this.emailI18n.closeConfirmation.alternate;
            }

            modalUtil.showGenericConfirm(config).then((result) => {
                if (result === 'confirm' && areRecipientsValid) {
                    this.onSaveDraftClick();
                }
                this.closePopup();
            });
        } else {
            this.closePopup();
        }
    };

    this.onSaveDraftClick = function () {
        this.options.saveEmail(this.getUpdatedEmail());
        this.closePopup();
    };

    this.showAddNewAttachmentModal = function (file) {
        modalUtil.showNewAttachmentModal(file, true).then(this.saveAttachment.bind(this));
    };

    this.getTitle = function () {
        return this.emailViewModel.draftTitle;
    };

    this.showAttachmentMultiSelect = function () {
        if (this.availableAttachments.length > 1) {
            this.isAttachmentDropdownOpen = true;

            $timeout(function () {
                let selectedAttachmentsUiSelectController;
                selectedAttachmentsUiSelectController = angular.element('.selectedAttachmentList .ui-select-match').controller('uiSelect');
                selectedAttachmentsUiSelectController.activate();
            }, 300);
        } else if (!this.isAttachmentDropdownOpen) {
            this.showAddNewAttachmentModal();
        }
    };

    this.hideIfNothingSelected = function () {
        if (this.selectedAttachments.length <= 0) {
            this.isAttachmentDropdownOpen = false;
        }
    };

    this.onSelect = function (item) {
        if (item.addAttachment) {
            _.remove(this.selectedAttachments, function (i) {
                return i.addAttachment === true;
            });
            this.showAddNewAttachmentModal();
        }
    };

    this.getUpdatedEmail = function () {
        let updatedEmail = _.cloneDeep(this.email);
        updatedEmail.subject = this.subject;
        updatedEmail.body = this.body;
        updatedEmail.to = (this.isModeUms) ? this.concatenateRecipients(this.toRecipients) : this.toRecipients;
        updatedEmail.cc = (this.isModeUms) ? this.concatenateRecipients(this.ccRecipients) : this.ccRecipients;
        updatedEmail.bcc = (this.isModeUms) ? this.concatenateRecipients(this.bccRecipients) : this.bccRecipients;

        updatedEmail.attachments = _.map(this.selectedAttachments, (selectedAttachment) => {
            delete selectedAttachment.submissionId;
            delete selectedAttachment.fieldAttachment;
            delete selectedAttachment.formTemplateDisplayName;
            delete selectedAttachment.objectUri;
            return selectedAttachment;
        });

        if (this.selectedEmailType) {
            updatedEmail.type = this.selectedEmailType.name;
        } else {
            updatedEmail.type = null;
        }

        return updatedEmail;
    };

    this.onSendClick = function () {
        this.options.sendEmail(this.getUpdatedEmail());
        this.closePopup();
    };

    this.toggleCc = function () {
        this.ccVisible = !this.ccVisible;
    };

    this.toggleBcc = function () {
        this.bccVisible = !this.bccVisible;
    };

    this.getUserId = function (item) {
        return _.isNumber(item.id) ? item.id : 0;
    };

    this.saveAttachment = function (data) {
        this.handleUploadAttachmentEmail({
            optionsData: this.options,
            data: data,
            selectedAttachments: this.selectedAttachments
        });
    };

    this.resolveRecipientObjects = function (recipients) {
        let recipientObjectList = [],
            recipientArray;
        if (recipients) {
            if (typeof (recipients) === 'string') {
                recipientArray = _.split(recipients, emailMessage.EMAIL_ADDRESS_SEPERATOR);
                if (!_.isEmpty(recipientArray)) {
                    _.each(recipientArray, (recipient) => {
                        recipientObjectList.push(this.getRecipientObject(recipient));
                    });
                }
            } else {
                _.each(recipients, (recipient) => {
                    recipientObjectList.push(this.extractRecipient(recipient));
                });
            }
        }
        return recipientObjectList;
    };

    this.extractRecipient = function (recipient) {
        let email = recipient.email,
            recipientObject = {};
        recipientObject.valid = true;
        recipientObject.id = recipient.id;

        if (!_.isNil(email)) {
            if (email.indexOf('@') > 0) {
                if (!_.isNil(recipient.name)) {
                    recipientObject.name = recipient.name;
                }
            } else {
                recipientObject.name = recipient.email;
            }
            recipientObject.emailAddress = email;
            return recipientObject;
        }
    };

    this.getRecipientObject = function (recipient) {
        let recipientObject = {},
            firstIndex,
            lastIndex,
            numberOfCharacters,
            name,
            emailAddress;

        if (recipient.indexOf('<') !== -1 && recipient.indexOf('>') !== -1) {

            firstIndex = recipient.indexOf('"');
            lastIndex = recipient.lastIndexOf('"');
            numberOfCharacters = lastIndex - firstIndex - 1;
            name = recipient.substr(firstIndex + 1, numberOfCharacters);

            firstIndex = recipient.indexOf('<');
            lastIndex = recipient.lastIndexOf('>');
            numberOfCharacters = lastIndex - firstIndex - 1;
            if (!name) {
                // Some recipients might not have their name in quotes, so take the string before the <
                name = recipient.substr(0, firstIndex - 1).trim();
            }
            emailAddress = recipient.substr(firstIndex + 1, numberOfCharacters);
            recipientObject.id = recipient.id;
            recipientObject.name = name;
            recipientObject.emailAddress = emailAddress;
        } else {
            recipientObject.emailAddress = recipient;
        }
        recipientObject.valid = true;
        return recipientObject;
    };

    this.concatenateRecipients = function (recipientList) {
        let recipientString;

        return _.join(_.map(recipientList, (recipient) => {
            recipientString = recipient.emailAddress;
            if (recipient.name) {
                recipientString = this.getEmailIdentifierString(recipient.name, recipient.emailAddress);
            } else {
                recipientString = recipient.emailAddress;
            }
            return recipientString;
        }), emailMessage.EMAIL_ADDRESS_SEPERATOR);
    };

    this.getEmailIdentifierString = (name, emailAddress) => {
        return `"${name}" <${emailAddress}>`;
    };

    this.loadUserList = function (userList) {
        if (!_.isNil(userList)) {
            this.peoplePickerList = this.getPeopleList(userList);
            this.filterItems();
            this.email = this.options.email;
            if (this.options.email.cc) {
                this.ccVisible = this.options.email.cc.length > 0;
            }
            if (this.options.email.bcc) {
                this.bccVisible = this.options.email.bcc.length > 0;
            }

            this.body = _.clone(this.options.email.body);
            this.subject = _.clone(this.options.email.subject);
            if (this.isModeUms) {
                this.isDraftEmail = this.options.email.status === emailMessageStatus.STATUS_DRAFT;
                this.selectedAttachments = _.clone(this.selectedEmailAttachments);
                this.isAttachmentDropdownOpen = this.isEmailAttachmentDropdownOpen;
                this.availableAttachments = this.availableEmailAttachments;
                this.canDeleteEmail = this.options.canDeleteEmail;
            }
        }

    };

    this.filterItems = function (searchText) {
        let filteredUsersList = [];
        const userListLength = this.peoplePickerList.length;
        const maxItems = 150;

        if (!_.isEmpty(searchText)) {
            filteredUsersList = _.filter(this.peoplePickerList, function (user) {
                return _.includes(user.name.toLowerCase(), searchText.toLowerCase());
            });
            //if after searching there are over 150 participants - still only display submissionParticipants
            if (filteredUsersList.length > maxItems) {
                filteredUsersList = this.submissionParticipantsList;
            }
        } else {
            if (userListLength > maxItems) {
                filteredUsersList = this.submissionParticipantsList;
            }else {
                filteredUsersList = this.peoplePickerList;
            }
        }
        this.filteredPeoplePickerList = filteredUsersList;

    };

    this.getPeopleList = function (users) {

        function matchRecipients(recipients, users) {
            // Match existing recipients with users in list to prevent duplicates.
            let updatedRecipients = [];

            _.each(recipients, function (recipient, index) {
                let user = null;
                user = _.find(users, function (o) {
                    if (!_.isNil(o.description)) {
                        return recipient.emailAddress === o.description;
                    } else if (!_.isNil(recipient.name)) {
                        return recipient.name && recipient.name === o.name && recipient.emailAddress === o.emailAddress;
                    } else {
                        return recipient.emailAddress === o.emailAddress;
                    }

                });
                if (user) {
                    updatedRecipients.push(user);
                } else {
                    if (_.isNil(recipient['id'])) {
                        recipient.id = 'a' + index;
                    }
                    updatedRecipients.push(recipient);
                }
            });

            return updatedRecipients;
        }

        this.toRecipients = matchRecipients(this.resolveRecipientObjects(this.options.email.to), users);
        this.ccRecipients = matchRecipients(this.resolveRecipientObjects(this.options.email.cc), users);
        this.bccRecipients = matchRecipients(this.resolveRecipientObjects(this.options.email.bcc), users);

        _.remove(users, function (user) {
            return user.group === 'User Groups';
        });

        _.map(users, function (user) {
            user.valid = true;
            user.id = null;
            return user;
        });
        const submissionParticipants =   users.filter(function(user) {
            return user.group === 'Submission Participants';
        });
        this.submissionParticipantsList = submissionParticipants;
        this.submissionParticipantsList.push({id: this.submissionParticipantsList.length, name: this.emailI18n.longListMessage, disabled: true });
        return users;

    };


    this.setupToolbar = function () {
        let attachmentTooltip = this.addAnAttachmentText,
            inserList = [];

        const AttachmentButton = function () {
            const ui = $.summernote.ui,
                button = ui.button({
                    className: 'dropdown-toggle',
                    contents: '<i class="glyphicon glyphicon-paperclip" uib-dropdown-toggle></i>',
                    tooltip: attachmentTooltip,
                    click: () => {
                        this.showAttachmentMultiSelect();
                    }
                });

            return button.render();
        };

        inserList.push('link');
        if (this.showAttachment) {
            inserList.push('attachment');
        }

        this.optionsList = {
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'underline', 'italic', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', inserList]
            ],
            buttons: {
                attachment: AttachmentButton.bind(this)
            },
            dialogsInBody: true,
            disableResizeEditor: true,
            disableLinkTarget: true,
            defaultLinkTargetNewWindow: true,
            disableDragAndDrop: true,
            fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Impact', 'Lato', 'Tahoma', 'Times New Roman', 'Verdana'],
            callbacks: {
                onKeyup: () => {
                    $timeout(() => {
                        this.updateEmailBody();
                    }, 250);
                },
                onBlur: () => {
                    $timeout(() => {
                        this.updateEmailBody();
                    }, 250);
                }
            },
            onCreateLink: function (linkUrl) {
                return linkUrl;
            },
            onCreateLinkText: function (linkText) {
                return linkText;
            }
        };
    };

    this.updateEmailBody = function () {
        $rootScope.$broadcast(emailEditorConstant.event.EMAIL_UPDATE_COMPLETE, this.getUpdatedEmail(), true);
    };

    this.loadAttachments = function () {
        this.loadEmailAttachments();
    };

    this.injectAddAttachmentOption = function () {
        if (this.availableAttachments) {
            if (this.availableAttachments.length > 0) {
                this.availableAttachments.push({name: this.addAnAttachmentText, addAttachment: true});
            }
        }
    };

    this.init = function () {
        this.getAttachmentTypes().then((result) => {
            this.typeDataItems = result;
            this.selectedEmailType = _.find(result, {name: this.options.email.type});
        });

        this.setupToolbar();
        if (this.isModeUms) {
            this.injectAddAttachmentOption();
        }

        loadingBarHandler.hideLoadingBar();
    };

    this.getAttachmentTypes = function () {
        return dataSetUtil.getDataItems({name: 'Attachment Types'});
    };

    this.handleChange = function () {
        $rootScope.$broadcast(emailEditorConstant.event.EMAIL_UPDATE_COMPLETE, this.getUpdatedEmail(), false);
    };

    this.getLabel = function (item) {
        return (item.description ? item.description : (item.name ? item.name : item.emailAddress));
    };
};

angular.module('gw-um-email-editor')
    .controller('emailEditorController', EmailEditorController);
